<aux-button-group variant="secondary" label="Add" [options]="options()" />
